'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.nativeAppService = exports.NativeAppService = void 0;
var NativeAppService = /** @class */ (function () {
    function NativeAppService() {
    }
    NativeAppService.prototype.postToApp = function (key, data) {
        if (typeof window.postToApp === 'function') {
            window.postToApp(key, data);
        }
    };
    NativeAppService.prototype.postLogout = function () {
        this.postToApp('logout', '');
    };
    NativeAppService.prototype.postSystemLogout = function () {
        this.postToApp('logout', 'systemLogout');
    };
    NativeAppService.prototype.trackEventToAdjust = function (key, data) {
        if (typeof window.trackEventToAdjust === 'function') {
            window.trackEventToAdjust(key, data);
        }
    };
    NativeAppService.prototype.trackFirstDeposit = function (revenue, currency) {
        this.trackDeposit(revenue, currency, 'first_deposit');
    };
    NativeAppService.prototype.trackDeposit = function (revenue, currency, key) {
        if (key === void 0) { key = 'deposit'; }
        this.trackEventToAdjust(key, {
            revenue: revenue,
            currency: currency,
        });
    };
    return NativeAppService;
}());
exports.NativeAppService = NativeAppService;
exports.nativeAppService = new NativeAppService();
